import { PageProps } from 'gatsby';
import { ReactNode } from 'react';
import { Layout } from 'components/layout/Layout';
import { LoadingLayout } from 'components/layout/LoadingLayout';
import { ArchiveLayout } from 'components/layout/ArchiveLayout';
import { PublicLayout } from 'components/layout/PublicLayout';
import { useFileData } from 'services/api/Results';
import { useUser } from 'services/User';

type ResultsLayoutProps = Omit<PageProps, 'children'> & { children?: ReactNode };

export const ResultsLayout = ({ children, ...props }: ResultsLayoutProps) => {
    const { user } = useUser();

    const { data: fileData, isLoading: isFileLoading } = useFileData();
    const { isLoading: isParentLoading } = useFileData({ dataId: fileData?.parent_data_id ?? null });
    const isLoading = isFileLoading || isParentLoading;
    const filesInArchive = fileData?.extracted_files?.files_in_archive;

    const isArchive = fileData?.parent_data_id || (Array.isArray(filesInArchive) && filesInArchive.length > 0);

    if (isLoading) {
        return <LoadingLayout {...props}>{children}</LoadingLayout>;
    }

    if (isArchive) {
        return <ArchiveLayout {...props}>{children}</ArchiveLayout>;
    }

    if (user?.isLoggedIn) {
        return <Layout {...props}>{children}</Layout>;
    }

    return <PublicLayout {...props}>{children}</PublicLayout>;
};
